export const assetFragment = `
  id: _id
  url
  size
  name
  assetType
  assetTarget
`;
